var EHDI = EHDI || Object.create(null);
var CKM = CKM || Object.create(null);
var UTILS = UTILS || Object.create(null);
var POOLS = POOLS || Object.create(null);

CKM.GameEngine  = function() 
{

    var TIME_LIMIT = EHDI.GAME.constants.gametimelimit;
    var SHUFFLE_TIME_PENALTY = 10;
    var GAME_SCALE =0.95;//0.875;

    EHDI.aka.Container.call(this);

    var ROW_COUNT =6;
    var COL_COUNT =15;
        var RIGHT_BOUNDS = COL_COUNT -1;
    var SLOT_WIDTH = 54;
    var SLOT_HEIGHT = 73;
    var YUMMY_BONUS = 2;

    var _parent = this;
    var _bg, _gizmoVisual, _cakeTray, _effectsLayer, _yummyMeter;

    var _timer, _isOver, _score, _scoreMultiplier, _yummyMultiplier; 
    var _pauseBtn, _scoreEffects;

    var _cakes, _slots;
    var _currCake;
    
    var _spark1, _spark2;
    var _bonusDisplay;

    var _gridPattern;


    var _init = function()
    {
        _bg = new EHDI.aka.Sprite(EHDI.Assets.images["cm_bg"]);
        this.addChild(_bg);

        _cakeTray = new EHDI.aka.Sprite();
        _cakeTray.x = 54+(EHDI.GAME.constants.boundWidth - (SLOT_WIDTH * COL_COUNT * GAME_SCALE)) * 0.5;
        _cakeTray.y = (EHDI.GAME.constants.boundHeight - (SLOT_HEIGHT * ROW_COUNT* GAME_SCALE) - 75) ;
        _cakeTray.scale.x = GAME_SCALE;
        _cakeTray.scale.y = GAME_SCALE;
        this.addChild(_cakeTray);



        _effectsLayer = new EHDI.aka.Sprite();
        // _effectsLayer.x = 54+ (EHDI.constants.boundWidth - (SLOT_WIDTH * COL_COUNT * GAME_SCALE)) * 0.5;
        // _effectsLayer.y = (EHDI.constants.boundHeight - (SLOT_HEIGHT * ROW_COUNT* GAME_SCALE) - 75) ;
        _effectsLayer.x = _cakeTray.x;
        _effectsLayer.y = _cakeTray.y ;
        _effectsLayer.scale.x = GAME_SCALE;
        _effectsLayer.scale.y = GAME_SCALE;
        this.addChild(_effectsLayer);


        _gizmoVisual = new EHDI.aka.Sprite(EHDI.Assets.images["cm_gizmo"]);
        _gizmoVisual.x = 40;
        _gizmoVisual.y = EHDI.GAME.constants.boundHeight - _gizmoVisual.height;
        this.addChild(_gizmoVisual);

        _yummyMeter = new CKM.YummyMeter();
        _yummyMeter.init();
        _yummyMeter.x = 74;
        _yummyMeter.y = 450;
        this.addChild(_yummyMeter);

        _timer = 0;
        _score = 0;
        _scoreMultiplier =1;
        
        _generateGrid();


        _spark1 = new EHDI.components.SparkleEffect();
        _spark1.scale.x = 0.5;
        _spark1.scale.y = 0.5;
        _effectsLayer.addChild(_spark1);
        _spark2 = new EHDI.components.SparkleEffect();
        _spark2.scale.x = 0.5;
        _spark2.scale.y = 0.5;
        _effectsLayer.addChild(_spark2);
                
        _scoreEffects = new EHDI.components.ScoreEffectManager();
        _scoreEffects.init(_effectsLayer);


        
    }
    this.init = _init.bind(this);

    var _generateGrid = function()
    {
        _cakes = [];

        if(_slots)
        {
            while(_slots.length > 0)
                {
                    var slot = _slots.pop();
                    slot.dispose();
                }
        }            
        _slots = [];

        _gridPattern = CKM.Patterns.getPattern();
        var gridPattern = _gridPattern.slice();
        var cakeDemand =0;

        //generate slots
        for(var j = 0; j < ROW_COUNT; j++)
        {
            for(var i = 0; i< COL_COUNT; i++)
            {
                var cakeSlot = POOLS.slotPool.takeFromPool();
                var stackSize = gridPattern.shift();
                cakeSlot.init(stackSize);
                cakeSlot.x = SLOT_WIDTH * i;
                cakeSlot.y = SLOT_HEIGHT * j;

                _slots.push(cakeSlot);
                cakeDemand += stackSize;
                _cakeTray.addChild(cakeSlot);
            }
        }
        
        //generate cake, place in _cakes
        for (var c =0, cLim = Math.floor(cakeDemand * 0.5); c <cLim; c++)
        {
            var cakeType = Math.floor(Math.random() * EHDI.GAME.constants.cakeVariationCount);
            var cake1 = POOLS.cakePool.takeFromPool();
            var cake2 = POOLS.cakePool.takeFromPool();

            cake1.init(cakeType);
            cake2.init(cakeType);

            _cakes.push(cake1);
            _cakes.push(cake2);
        }
        

        //fill vacant slots with cake
        _placeCakes();
    }

    var _dispose = function()
    {
        _parent.removeChildren();

        // var _bg, _gizmoVisual, _cakeTray;
    
        // var _timer, _isOver, _score, _scoreMultiplier; 
        // var _pauseBtn, _scoreEffects;
    
        // var _cakes, _slots;
        // var _currCake;
        
        // _spark1 = null;
        // _spark2 = null;
    }
    this.dispose = _dispose.bind(this);


    var _gameStart = function()
    {
        _pauseBtn =EHDI.GAME.pauseButton;

        _addInteraction();
        
        // this.bindedLoop = gameUpdate.bind(this);
        // EHDI.GAME.updateManager.addFrameListener(this.bindedLoop);
        EHDI.GAME.updateManager.addFrameListener(_gameUpdate);
    }
    this.gameStart = _gameStart.bind(this);


    var _gameUpdate= function(delta)
    {
        if(_bonusDisplay)
        {
            if(_bonusDisplay.update(delta))
                {
                    _endGame();
                }
            return;
        }

        if((_pauseBtn.isPaused) || (_pauseBtn.isEndGame))
            {                
                return;
            }
        _timer += delta;
        if((_timer >=  TIME_LIMIT) || (_isOver))
            {
                _gameOver();
                return;
            }

            

        for(var i=0, l = _cakes.length; i< l; i++)
        {
            _cakes[i].update(delta);
        }

        if(_scoreEffects)
        _scoreEffects.update(delta);

        if(_yummyMeter)
        {
            _yummyMeter.update(delta);

            if(_yummyMeter.yummyTime)
                _yummyMultiplier =YUMMY_BONUS;
            else
                _yummyMultiplier =1;
        }

        if(EHDI.scene.GameScene.timer.timeLeft <= 10)
            EHDI.scene.GameScene.shuffleBtn.visible = false;

    }

    var _gameOver = function(isWin)
    {
        if(_isOver)
            return;

        if(_yummyMeter.yummyTime)
            _yummyMeter.deactivateYummy();
            
        _removeInteraction();
//        _scoreEffects.hideScores();
        EHDI.GAME.pauseButton.endGame();

        var bonusPts = 0;
         _isOver = true;        
         if(!isWin)
         {
            _endGame();
            //_proceedToWrapper();
         }
        else
        {
            bonusPts = Math.floor(EHDI.scene.GameScene.timer.timeLeft) *10;
            EHDI.scene.GameScene.scoreHolder.addSparkles(bonusPts);
            
            
            
            _bonusDisplay = new EHDI.components.BonusDisplay();
            
            EHDI.scene.GameScene.multiplier.visible = false;
            _bonusDisplay.appear();
            EHDI.GAME.bgm.stop();
            EHDI.GAME.soundManager.playSFX("bonus");
            CKM.gameScene.addChild(_bonusDisplay);
            // _proceedToWrapper();
        }
    }
    this.gameOver = _gameOver.bind(this);

    var _endGame = function() {
        var score = EHDI.scene.GameScene.scoreHolder.getScore();

        var cache = EHDI.GAME.storageManager.getLocalInfo(EHDI.GAME.id);
        if(score > cache.highScore) {
            EHDI.GAME.storageManager.setLocalInfo(EHDI.GAME.id, cache);
            cache.highScore = score;
        }

        if(EHDI.GAME.constants.gameEndFunction) {
            EHDI.GAME.soundManager.autoResumeToggle(true);
            EHDI.GAME.pauseButton.endGame();
            EHDI.GAME.constants.gameEndFunction(EHDI.GAME.constants.gameName, EHDI.scene.GameScene.scoreHolder.getScore());   
        } else {
            var star = 0;
            if(score > 0 && score < 750) {
                star = 1;
            } else if (score >= 750 && score < 1500) {
                star = 2;
            } else if (score >= 1500) {
                star = 3;
            }
     
            EHDI.GAME.soundManager.playSFX("score_points"); //error like sound
            EHDI.GAME.soundManager.autoResumeToggle(true);
            EHDI.GAME.pauseButton.endGame();
            EHDI.GAME.sceneManager.pushPopUp(new EHDI.popup.PostGamePopUp(star, score), {y : new EHDI.scene.TransitionParameter(-EHDI.GAME.sceneManager.getStageHeight(), EHDI.GAME.sceneManager.getStageHeight() * 0.5), duration : 0.25});
        }
    }

    var _proceedToWrapper = function()
    {
        _bonusDisplay = null;
        var score = EHDI.scene.GameScene.scoreHolder.getScore();
        if(score > EHDI.GAME.saveData.highScore) {
            EHDI.GAME.saveData.highScore = score;
            EHDI.sbGame.saveGameData(EHDI.GAME.saveData, "DEFAULT", function(){
                console.log("data saved.");
            });
        }
        EHDI.sbGame.end(score);
        
    }
   
  
    var _getStarRating = function()
    {
        var rating = Math.floor(_score / 250);

        if(rating > 3)
            rating =3;
        
        return rating;
    }
    
    var _addInteraction = function()
    {
    }

    var _removeInteraction = function()
    {
    }



    /////// Game Specific Functions
    var _placeCakes = function()
    {
        var availableSlots = [];
        for(var s= 0, sLim = _slots.length; s < sLim; s++)
        {
            var slot = _slots[s];
            var stackLimIter = 0;
            var slotStackLim = slot.stackLimit;

            if(slot)
            {
                while(stackLimIter < slotStackLim)
                {
                    availableSlots.push(slot);
                    stackLimIter++;
                }
            }
        }


        for(var c = 0, cLim = _cakes.length; c <cLim; c++)
        {
            var cake = _cakes[c];

            var slot;
            var success = false;
            var previous, previousTopType;
            do
            {
                
                var availableSlotCount = availableSlots.length;
                var forcePush = (availableSlotCount <= 1);
                var randomIndex = Math.floor(Math.random() * availableSlotCount);
                
                slot = availableSlots[randomIndex]; 
                previousTopType = slot.topCakeType;
                while((slot.topCakeType === cake.type) || (forcePush && previousTopType === cake.type)) {
                    if(forcePush) {
                        var cakeType = Math.floor(Math.random() * EHDI.GAME.constants.cakeVariationCount);
                        cake.updateType(cakeType);
                        previous.updateTopCakeType(cakeType);
                    } else {
                        randomIndex = Math.floor(Math.random() * availableSlotCount);
                        slot = availableSlots[randomIndex];
                    }
                }

                //place on a random CakeSlot from slotsDupe
                if(slot) {
                    success =slot.push(cake, forcePush);
                    if(success)
                        previous = slot;
                }

                if(success)
                {
                    if(randomIndex > -1) {
                        availableSlots.splice(randomIndex, 1);
                        
                    }
                }

            }while(!success);
                
        }

        
        if(!_checkForPossibleMove())
        {
            _shuffleTray(false)
        }

    }

    var _checkVacantNeighbor = function(currSlot)
    {
        var currIndex = _slots.indexOf(currSlot);
        var colPosition = (currIndex % COL_COUNT);
        var currStackSize = _slots[currIndex].stackSize;

        //If currSlot is on the left/right most side of the border
        if((colPosition <= 0) || (colPosition >= RIGHT_BOUNDS))
            return true

        //If there is a neighbor with a smaller stack
        if((_slots[currIndex - 1].stackSize < currStackSize ) || (_slots[currIndex + 1].stackSize < currStackSize ))
            return true;

        return false;
    }

    var _checkForPossibleMove = function()
    {
        var availableTypes = [];

        for(var s = 0, sLim = _slots.length; s < sLim ;s++)
        {
            if(_slots[s].stackSize <= 0)
                continue;

            var currentType =_slots[s].topCakeType;

            if(currentType == -1)
                continue;

            if(!_checkVacantNeighbor(_slots[s])) //slot is not a valid move
                continue;

            if(availableTypes.indexOf(currentType) == -1) //type not found in array
            {
                availableTypes.push(currentType);
            }
            else //type found in array
            {
                // console.log(_slots[s].topCakeType, availableTypes);
                //possible move found
                availableTypes = null;
                return true;
            }
        }

        //no possible move found
        availableTypes = null;
        return false;
    }

    var _shuffleTray = function(hasPenalty)
    {
        if(hasPenalty)
        {
            _timer += SHUFFLE_TIME_PENALTY * 1000;
            EHDI.scene.GameScene.timer.addTime(SHUFFLE_TIME_PENALTY *-1);
            EHDI.scene.GameScene.shuffleBtn.visible = false;
        }
        _replaceCakeTypes();
//        }

        // _currCake = null;
        // for(var s = 0, sLim = _slots.length; s < sLim ;s++)
        // {
        //     _slots[s].reset();
        // }

        // _placeCakes();
    }
    
    var _autoShuffle = function() {
        _currCake = null;
        var existingCakes = [];
        var gridPattern = _gridPattern.slice();
        
        for(var s = 0; s < _slots.length; s++) {
            var stackSize = gridPattern.shift();
            existingCakes = existingCakes.concat(_slots[s].emptyCakeSlot());
            console.log(existingCakes);
            _slots[s].resizeCakeSlot(stackSize);
        }
        
        var availableSlots = [];
        for(var s= 0, sLim = _slots.length; s < sLim; s++)
        {
            var slot = _slots[s];
            var stackLimIter = 0;
            var slotStackLim = slot.stackLimit;

            if(slot)
            {
                while(stackLimIter < slotStackLim)
                {
                    availableSlots.push(slot);
                    stackLimIter++;
                }
            }
        }
        
        for(var c =0; c < existingCakes.length; c++) {
            var cake = existingCakes[c];
            
            var slot;
            var success = false;
            var previous, previousTopType;
            do
            {
                
                var availableSlotCount = availableSlots.length;
                var forcePush = (availableSlotCount <= 1);
                var randomIndex = Math.floor(Math.random() * availableSlotCount);
                
                slot = availableSlots[randomIndex]; 
                previousTopType = slot.topCakeType;
                while((slot.topCakeType === cake.type) || (forcePush && previousTopType === cake.type)) {
                    if(forcePush) {
                        var cakeType = Math.floor(Math.random() * EHDI.GAME.constants.cakeVariationCount);
                        cake.updateType(cakeType);
                        previous.updateTopCakeType(cakeType);
                    } else {
                        randomIndex = Math.floor(Math.random() * availableSlotCount);
                        slot = availableSlots[randomIndex];
                    }
                }

                //place on a random CakeSlot from slotsDupe
                if(slot) {
                    success =slot.push(cake, forcePush);
                    if(success)
                        previous = slot;
                }

                if(success)
                {
                    if(randomIndex > -1) {
                        availableSlots.splice(randomIndex, 1);
                        
                    }
                }

            }while(!success);
                
        }

        
        if(!_checkForPossibleMove())
        {
            _shuffleTray(false)
        }
        
    }

    var _replaceCakeTypes = function()
    {
        var typeColl = [];
        var unmatched = [];

        for(var s = 0, sLim = _slots.length; s < sLim ;s++)
        {
            var typesInSlot = _slots[s].stackClearType();

            while(typesInSlot.length > 0)
            {
                var type = typesInSlot.pop();
                var typeIndex = unmatched.indexOf(type);

                if(typeIndex == -1)
                {
                    typeColl.push(type);
                    typeColl.push(type);
                    unmatched.push(type);
                }
                else
                {
                    unmatched[typeIndex] = null;                    
                }
            }
        }


        var availableSlots = [];
        for(var s= 0, sLim = _slots.length; s < sLim; s++)
        {
            var slot = _slots[s];
            var stackLimIter = 0;
            var slotStackLim = slot.stackLimit;

            if(slot)
            {
                while(stackLimIter < slotStackLim)
                {
                    availableSlots.push(slot);
                    stackLimIter++;
                }
            }
        }

        for(var c = 0, cLim = typeColl.length; c <cLim; c++)
        {
            var type = typeColl[c];

            var slot;
            var success = false;
            var previous, previousTopType;
            do
            {
                
                var availableSlotCount = availableSlots.length;
                var forcePush = (availableSlotCount <= 1);
                var randomIndex = Math.floor(Math.random() * availableSlotCount);



                slot = availableSlots[randomIndex];
                previousTopType = slot.topCakeType;
                while((slot.topCakeType === type) && (forcePush && previousTopType === type)) {
                    console.log(slot.topCakeType, previousTopType);
                    if(forcePush) {
                        var cakeType = Math.floor(Math.random() * EHDI.GAME.constants.cakeVariationCount);
                        slot.updateCakeType(cakeType);
                        previous.updateTopCakeType(cakeType);
                    } else {
                        randomIndex = Math.floor(Math.random() * availableSlotCount);
                        slot = availableSlots[randomIndex];
                    }
                }

                //update a random CakeSlot from slotsDupe
                if(slot) {
                    success =slot.updateCakeType(type);
                    if(success)
                        previous = slot;
                }

                if(success)
                {
                    if(randomIndex > -1)
                        availableSlots.splice(randomIndex, 1);
                }

            }while(!success);
                
        }

        for(var s = 0; s < _slots.length; s++) {
            _slots[s].capStack();
        }
        
        if(!_checkForPossibleMove())
        {
            _shuffleTray(false)
        }

    }

    var _matchCake = function(cake)
    {

        if(!_currCake)
        _currCake = cake;
        else
        {
            if(_currCake == cake)
            {
                // _currCake.untap();
                // _currCake = cake;
                return;
            }

            if(cake.topCakeType == _currCake.topCakeType)
            {
                var cake1 =_currCake.pop();
                var cake2 = cake.pop();
                
               
                var worth =cake1.worth * _scoreMultiplier * _yummyMultiplier;
                var cakeEffectX = cake.effectPtX;
                var cakeEffectY = cake.effectPtY;
                var currCakeEffectX = _currCake.effectPtX;
                var currCakeEffectY =  _currCake.effectPtY;

                EHDI.GAME.soundManager.playSFX("correct");

                if(worth > 0)
                {
                    _scoreEffects.popScore(cakeEffectX, cakeEffectY, worth);
                    _scoreEffects.popScore(currCakeEffectX, currCakeEffectY, worth);
                    EHDI.scene.GameScene.scoreHolder.addScore(worth * 2);
                }
                _spark1.appear(cakeEffectX, cakeEffectY);
                _spark2.appear(currCakeEffectX, currCakeEffectY);
                _yummyMeter.levelUp();


                UTILS.arrayUtils.removeFromArray(_cakes, [cake1] );
                UTILS.arrayUtils.removeFromArray(_cakes, [cake2] );

                _scoreMultiplier = cake1.multiplier;
                if(_scoreMultiplier == 5)
                    EHDI.scene.GameScene.multiplier.visible  = true;
                else
                    EHDI.scene.GameScene.multiplier.visible = false;

                _currCake = null;

                cake1.dispose();
                cake2.dispose();

                
                if(_cakes.length <= 0)
                {
                    _parent.gameOver(true);
                    return;
                }
                else if(!_checkForPossibleMove())
                {
                    EHDI.GAME.pauseButton.isPaused = true;
                    CKM.gameScene.addChild(new EHDI.components.noMoreMatchNotif());
                    _autoShuffle();
                }
                if(EHDI.scene.GameScene.timer.timeLeft > 10)
                    EHDI.scene.GameScene.shuffleBtn.visible = true;
                
            }
            else
            {
                _currCake.untap();
                _currCake = cake;
            }
        }
    }



    this.checkVacantNeighbor = _checkVacantNeighbor.bind(this);
    this.shuffleTray = _shuffleTray.bind(this);
    this.matchCake = _matchCake.bind(this);


    CKM.gameInstance = _parent;
}
CKM.GameEngine.prototype = Object.create(EHDI.aka.Container.prototype);

